module.exports = __webpack_public_path__ + "img/black.d91dd6ef.jpg";